export const destinosDisponibles = [
  { value: "PUJ", label: "Punta Cana" },
  { value: "CUN", label: "Cancún" },
  { value: "GIG", label: "Brasil" },
  { value: "PERU", label: "Perú" },
  { value: "AUA", label: "Aruba" },
  { value: "CUR", label: "Curazao" },
  { value: "MBJ", label: "Jamaica" },
  { value: "PTY", label: "Panamá Playa" },
  { value: "PTYC", label: "Panamá Ciudad" },
  { value: "VRA", label: "Varadero" },
  { value: "HAV", label: "Habana" },
  { value: "PCM", label: "Playa Del Carmen" },
  { value: "MEX", label: "Ciudad de México" },
  { value: "JPN", label: "Japón" },
  { value: "JPN GUIA", label: "Japón Con Guía" },
  { value: "SJD", label: "Los Cabos" },
  { value: "CTG", label: "Cartagena" },
  { value: "SMR", label: "Santa Marta" },
  { value: "ADZ", label: "San Andrés" },
  { value: "BKK", label: "Tailandia" },
  { value: "PTY COMBINADO", label: "Panamá Combinado" },
  { value: "HAV COMBINADO", label: "Habana Combinado" },
  { value: "MEX COMBINADO", label: "México Combinado" },
  { value: "DECAMERON", label: "Decameron" },


]

// Código ISO 3166-1 alpha-2 del país de cada destino (para banderas)
export const paisesDestinos = {
  PUJ: "do",
  CUN: "mx",
  GIG: "br",
  PERU: "pe",
  AUA: "aw",
  CUR: "cw",
  MBJ: "jm",
  PTY: "pa",
  PTYC: "pa",
  "PTY COMBINADO": "pa",
  VRA: "cu",
  HAV: "cu",
  "HAV COMBINADO": "cu",
  PCM: "mx",
  MEX: "mx",
  "MEX COMBINADO": "mx",
  SJD: "mx",
  JPN: "jp",
  "JPN GUIA": "jp",
  CTG: "co",
  SMR: "co",
  ADZ: "co",
  BKK: "th",
}